module.exports = __webpack_public_path__ + "static/media/conflict.72e7ce88.jpg";